import React, { useState } from "react";
import { TextField, Button, Typography, Box, Paper } from "@mui/material";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState(1); // Track steps (1 = email input, 2 = OTP input, 3 = reset password)
  const [errors, setErrors] = useState({});
  
  const handleEmailSubmit = () => {
    const newErrors = {};

    // Email validation
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!validateEmail(email)) {
      newErrors.email = "Invalid email format.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Simulate sending OTP to email (here you should integrate with your backend)
      alert(`OTP sent to ${email}`);
      setStep(2); // Move to OTP input step
    }
  };

  const handleOtpSubmit = () => {
    const newErrors = {};

    // OTP validation
    if (!otp) {
      newErrors.otp = "OTP is required.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Simulate OTP verification (integrate with your backend)
      alert("OTP verified successfully.");
      setStep(3); // Move to new password input step
    }
  };

  const handlePasswordReset = () => {
    const newErrors = {};

    // New password validation
    if (!newPassword) {
      newErrors.newPassword = "New password is required.";
    } else if (!validatePassword(newPassword)) {
      newErrors.newPassword = "Password must be at least 8 characters long and contain at least one letter and one number.";
    }

    // Confirm password validation
    if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Simulate password reset (integrate with your backend)
      alert("Password reset successful!");
      // Redirect to login or home page
    }
  };

  // Email validation using regex
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Password validation (minimum 8 characters, at least one letter and one number)
  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    return passwordRegex.test(password);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="90vh"
      bgcolor="#f5f5f5"
      p={2}
    >
      <Typography variant="h3" align="center" gutterBottom>
        Forgot Password
      </Typography>

      <Paper elevation={6} sx={{ padding: 4, width: "100%", maxWidth: 400, mt: 2 }}>
        {step === 1 && (
          <>
            <Typography variant="h5" align="center" gutterBottom>
              Enter your email to receive a password reset link.
            </Typography>

            <TextField
              label="Email"
              variant="outlined"
              margin="normal"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!errors.email}
              helperText={errors.email}
            />

            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleEmailSubmit}
              sx={{
                width: "100%",
                mt: 2,
                "&:hover": {
                  backgroundColor: "#1565c0", // Darker blue on hover
                },
              }}
            >
              Send OTP
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            <Typography variant="h5" align="center" gutterBottom>
              Enter the OTP sent to your email.
            </Typography>

            <TextField
              label="OTP"
              variant="outlined"
              margin="normal"
              fullWidth
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              error={!!errors.otp}
              helperText={errors.otp}
            />

            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleOtpSubmit}
              sx={{
                width: "100%",
                mt: 2,
                "&:hover": {
                  backgroundColor: "#1565c0", // Darker blue on hover
                },
              }}
            >
              Verify OTP
            </Button>
          </>
        )}

        {step === 3 && (
          <>
            <Typography variant="h5" align="center" gutterBottom>
              Set a new password
            </Typography>

            <TextField
              label="New Password"
              variant="outlined"
              margin="normal"
              fullWidth
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              error={!!errors.newPassword}
              helperText={errors.newPassword}
            />

            <TextField
              label="Confirm Password"
              variant="outlined"
              margin="normal"
              fullWidth
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
            />

            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handlePasswordReset}
              sx={{
                width: "100%",
                mt: 2,
                "&:hover": {
                  backgroundColor: "#1565c0", // Darker blue on hover
                },
              }}
            >
              Reset Password
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}

export default ForgotPassword;
